/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type SharedAnalysisNotFoundErrorCode = (typeof SharedAnalysisNotFoundErrorCode)[keyof typeof SharedAnalysisNotFoundErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedAnalysisNotFoundErrorCode = {
  analysis_not_found: "analysis_not_found",
  nsure_agent_not_found: "nsure_agent_not_found",
} as const;
